import { LitElement, html } from 'lit'
import { customElement, state, property } from 'lit/decorators.js'
import { polarRouteSelectionStyles } from '../styles/polar-route-selection-styles'
import '@maersk-global/mds-components-core'
import { Coordinate } from 'ol/coordinate'
import { VesselPositionModel } from '../../../src/models/vessel-position-model'
import { CoordinatesUtils } from '../../../src/utils/coordinates-utils'
import { VoyageTopbarEventNames } from './types/topbar-events.types'

@customElement('polar-route-selection')
export class PolarRouteSelection extends LitElement {
    @property({ type: Array })
    polarRouteCapturedPosition: Coordinate | null = null
    @state()
    private internalPolarRoutePosition: Coordinate | null = null
    @property({ type: Boolean }) hasParametricRisk: boolean = false
    @property({ type: Boolean }) hasActivePlan: boolean = false

    static styles = polarRouteSelectionStyles

    constructor() {
        super()
        this.getCurrentVesselPosition = this.getCurrentVesselPosition.bind(this)
    }

    connectedCallback() {
        super.connectedCallback()
        this.internalPolarRoutePosition = this.polarRouteCapturedPosition
    }

    updated(changedProperties: Map<string | number | symbol, unknown>) {
        if (changedProperties.has('polarRouteCapturedPosition')) {
            this.internalPolarRoutePosition = this.polarRouteCapturedPosition
        }
    }

    private getCurrentVesselPosition = () => {
        const position = VesselPositionModel!.position

        if (
            !position ||
            position.latitude === null ||
            position.longitude === null
        ) {
            return
        }

        const coords = [position.longitude, position.latitude] as Coordinate        

        this.internalPolarRoutePosition = coords
    }

    render() {
        return html`
            <div class="polar-route-selection-background">
                <div class="container">
                    <span class="title">Polar Chart Advice</span>
                    <div class="polar-route-selection">
                        <div class="input">
                            <mc-input
                                label="Please choose any point on your voyage to view
                                Polar chart."
                                placeholder="Click on route to select position"
                                name="coordinates"
                                .value="${this.internalPolarRoutePosition
                                    ? CoordinatesUtils.formatCoordinates(
                                          this.internalPolarRoutePosition,
                                      )
                                    : null}"
                                labelposition="left"
                                readonly
                            >
                            </mc-input>
                            <div class="select-current-position">
                                <button
                                    class="select-current-position--btn"
                                    @click=${this.getCurrentVesselPosition}
                                >
                                    <mc-tooltip>
                                        <mc-icon
                                            icon="crosshair"
                                            slot="trigger"
                                        ></mc-icon>
                                        <span
                                            >Select the vessel’s current
                                            location</span
                                        >
                                    </mc-tooltip>
                                </button>
                            </div>
                        </div>
                        <div class="button-wrapper">
                            <mc-button
                                appearance="neutral"
                                fit="medium"
                                @click=${() =>
                                    this.dispatchEvent(new Event(VoyageTopbarEventNames.ClosePolarRouteSelection))}
                                >Cancel</mc-button
                            >
                            <mc-tooltip position="bottom-center">
                                <mc-button
                                    appearance="primary"
                                    variant="filled"
                                    fit="medium"
                                    slot="trigger"
                                    .disabled=${!this.internalPolarRoutePosition || !this.hasActivePlan}
                                    @click=${() => {
                                        this.dispatchEvent(
                                            new CustomEvent(
                                                VoyageTopbarEventNames.ShowPolarChart,
                                                {
                                                    detail: {
                                                        position: this.internalPolarRoutePosition,
                                                    },
                                                    bubbles: true,
                                                    composed: true,
                                                },
                                            ),
                                        );
                                    VesselPositionModel!.dispatchEvent(new CustomEvent('polar-plot-position-changed', {detail: {position: this.internalPolarRoutePosition}}))
                                    }}
                                    >Continue
                                </mc-button>
                                ${!this.hasActivePlan ? html`<span>You have no active plan</span>`: null}
                            </mc-tooltip>
                        </div>
                    </div>
                </div>
            </div>
        `
    }
}
